import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
interface UseAppearOnScrollOptions {
  threshold?: number;
}
export const useAppearOnScroll = t0 => {
  const $ = _c(7);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    threshold: t2
  } = t1;
  const threshold = t2 === undefined ? 0 : t2;
  const [shouldAppear, setShouldAppear] = useState(false);
  let t3;
  let t4;
  if ($[2] !== threshold) {
    t3 = () => {
      const handleScroll = () => {
        const scrollY = window.scrollY || window.pageYOffset;
        setShouldAppear(scrollY > threshold);
      };
      handleScroll();
      window.addEventListener("scroll", handleScroll, {
        passive: true
      });
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    };
    t4 = [threshold];
    $[2] = threshold;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  if ($[5] !== shouldAppear) {
    t5 = {
      shouldAppear
    };
    $[5] = shouldAppear;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};